export const DisableOverflow = () => {
  document.body.style.overflowY = "hidden";
};

export const EnableOverflow = () => {
  document.body.style.overflowY = "auto";
};
